$(document).ready(function () {
  let p = $("body").attr("p");
  let organizerId = $("body").attr("organizer_id");
  const body = $("body");
  let storageModalAjaxLock = false;
  let orderStorageIdentifierSelectAjaxLock = false;
  let isLongPress = false;
  let longPressTimer;
  let shop_type = $("body").attr("shop_type");
  let tableId = $("#event-public-list-organizer").attr("data-table-number") || null;
  let selectedTableNumber = "";
  let tableCustomerId = "";
  if (p === "events_self_service" && shop_type == "dine-in") {
    function checkPaymentStatusByCustomerAndTableId(tableId, tableCustomerId) {
      $.ajax({
        type: "POST",
        url: "/ajax/order/get_saved_order_table_payment_status",
        data: {
          organizer_id: organizerId,
          table_id: tableId,
          table_customer_id: tableCustomerId,
          shop_type,
        },
      })
        .done(function (data) {
          if (data && data.length > 0) {
            selectedTableNumber = localStorage.getItem("saved_table_id");
            tableCustomerId = localStorage.getItem("saved_table_customer_id");
            locationCart.table_number = localStorage.getItem("saved_table_id");
            $("#view-saved-table-contanier").attr(
              "data-table-id",
              selectedTableNumber,
            );
            $("#view-saved-table-contanier").attr(
              "data-table-customer-id",
              tableCustomerId,
            );
            $("#view-saved-table-contanier").removeClass("d-none");
            $(".save_order_self_service").attr(
              "data-identifier",
              selectedTableNumber,
            );
            $(".save_order_self_service").attr(
              "data-table-customer_id",
              tableCustomerId,
            );
          } else {
            localStorage.removeItem("saved_table_id");
            localStorage.removeItem("saved_table_customer_id");
            emptyAllCart();
            $("#view-saved-table-contanier").addClass("d-none");
            $("#view-saved-table-contanier").attr("data-table-id", "");
            $("#view-saved-table-contanier").attr("data-table-customer-id", "");
            $(".save_order_self_service").attr("data-identifier", "");
            $(".save_order_self_service").attr("data-table-customer_id", "");
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
          console.error("fail to check paymenet status");
          return false;
        });
    }

    if (
      localStorage.getItem("saved_table_id") &&
      localStorage.getItem("saved_table_customer_id")
    ) {
      checkPaymentStatusByCustomerAndTableId(
        localStorage.getItem("saved_table_id"),
        localStorage.getItem("saved_table_customer_id"),
      );
    }
  }

  if (p === "events" || p === "events_self_service") {
    if (tableId) {
      locationCart.table_number = tableId;
      selectedTableNumber = tableId;
      $(".save_order_self_service").attr(
        "data-identifier",
        selectedTableNumber,
      );
    }

    const organizerId = $(body).attr("organizer_id");
    const error_message = $(body).attr("error_message") ?? null;
    let locationId =
      $("#classic-location-products").attr("data-location-id") ??
      $("#location").attr("data-location-id");
    let posType = $("#classic-location-products").attr("data-pos-type");
    let orderStorageIdentifierFormSubmitAjaxLock = false;

    if (error_message && localStorage.getItem("saved_table_id")) {
      selectedTableNumber = localStorage.getItem("saved_table_id");
    }

    $(document).on("click", ".self-service-table", function (e) {
      e.preventDefault();
      selectedTableNumber = $(this).attr("data-table-name");
      locationCart.table_number = selectedTableNumber;
      $("#self-service-table-select-btn").text(selectedTableNumber);
      $(".save_order_self_service").attr(
        "data-identifier",
        selectedTableNumber,
      );

      $(".save_order_self_service").attr("data-extra-table", "");
      $("#selfServiceTableModel").modal("hide");
      $("#cart-table-number").text(selectedTableNumber);
      $(".save_order_self_service").prop("disabled", false);
      $("#proceed-to-checkout").prop("disabled", false);
      $(".show-customer-name-collapse").prop("disabled", false);
      $("#self-service-action-wrapper").removeClass("d-none");
      $("#self-service-action-wrapper").addClass("d-flex");
      adjustProductsHeight();
    });

    $(document).on("click", ".show-customer-name-collapse", function (e) {
      if (localStorage.getItem("saved_table_customer_id")) {
        $(".save_order_self_service").attr(
          "data-table-customer-id",
          localStorage.getItem("saved_table_customer_id"),
        );
        setTimeout(() => {
          $(".save_order_self_service").trigger("click");
        }, 200);
      } else if ($("#table-customer-name").val()) {
        $(".save_order_self_service").trigger("click");
      } else if ($(this).attr("aria-expanded") === "true") {
        $(this).attr("aria-expanded", false);
        $("#table-customer-name-collapse").collapse("hide");
      } else {
        $(this).attr("aria-expanded", true);
        $("#table-customer-name-collapse").collapse("show");
      }
      setTimeout(() => {
        adjustProductsHeight();
      }, 500);
    });

    $(document).on(
      "click",
      "#view-saved-table, #view-saved-table-contanier",
      function (e) {
        e.preventDefault();
        if (!orderStorageIdentifierSelectAjaxLock && !isLongPress) {
          orderStorageIdentifierSelectAjaxLock = true;

          if (locationCart.number_of_products == 0) {
            const identifier = $(this).attr("data-table-id");
            const tableCustomerId = $(this).attr("data-table-customer-id");
            const extraTable = "";
            const cart_products = [];
            locationCart.products = [];
            locationCart.customer_id = "";
            $(".customer-item").removeClass("selected");
            locationCart.checkout_type = "";
            $.ajax({
              type: "POST",
              url: "/ajax/order/get_saved_order_table",
              data: {
                organizer_id: organizerId,
                location_id: locationId,
                table_id: identifier,
                extra_table_id: extraTable,
                table_customer_id: tableCustomerId,
                cart_products,
                shop_type,
                is_view_saved_product: 1,
              },
            })
              .done(function (data) {
                if (
                  data.location_id !== undefined &&
                  data.location_id !== null &&
                  data.location_id == locationId
                ) {
                  $("#order-storage-list-modal").modal("hide");
                  $(".modal-backdrop").remove();
                  if (data.is_view_saved_product == 1) {
                    isViewSavedProduct = true;
                  }
                  if (posType === "classic") {
                    setClassicLocationCart(data);
                  } else {
                    setLocationCart(data);
                  }
                }
              })
              .fail(function (data) {
                if (
                  data.responseJSON.redirect_url !== undefined &&
                  data.responseJSON.redirect_url !== null
                ) {
                  document.location.href = data.responseJSON.redirect_url;
                }
              })
              .always(function () {
                setTimeout(function () {
                  orderStorageIdentifierSelectAjaxLock = false;
                }, 3000);
              });
          }
        }
      },
    );

    $(document).on("hide.bs.modal", "#cart-modal", function (event) {
      $(".modal-backdrop").remove();
      orderStorageIdentifierSelectAjaxLock = false;
    });

    $(document).on("hide.bs.modal", "#payment-split-modal", function (event) {
      $(".modal-backdrop").remove();
    });

    $(document).on("click", ".save_order_self_service", function (e) {
      e.preventDefault();
      if (
        !$(this).attr("data-identifier") ||
        $(this).attr("data-identifier") == ""
      ) {
        $(".self-service-table").focus();
        return alert("Velg bord først");
      }
      selectedTableNumber = $(this).attr("data-identifier");
      const customerName = $("#table-customer-name").val();
      const identifier = $(this).data("identifier");
      const tableCustomerId = $(this).data("table-customer-id");
      const cart_products = locationCart.products;
      const extraTable = $(this).attr("data-extra-table");

      if (!identifier) {
        return alert("no table selected");
      }

      if (!customerName && !localStorage.getItem("saved_table_customer_id")) {
        alert("please enter customer name");
        $("#table-customer-name").focus();
        return;
      }

      if (cart_products.length <= 0) {
        return alert("No item in cart");
      }

      $.ajax({
        type: "POST",
        url: "/ajax/order/save_order_product",
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          table_id: identifier,
          extra_table_id: extraTable,
          table_customer_id: tableCustomerId,
          cart_products,
          comment: locationCart.comment,
          customer_name: customerName,
          self_service_table: 1,
        },
      })
        .done(function (data) {
          if (data && data.customer_id) {
            $("#view-saved-table-contanier").attr(
              "data-table-id",
              selectedTableNumber,
            );
            $("#view-saved-table-contanier").attr(
              "data-table-customer-id",
              data.customer_id,
            );
            $("#view-saved-table-contanier").removeClass("d-none");
            emptyAllCart();
            popupAlert();
            $("#cart-modal").modal("hide");
            $(".table-responsive").empty();

            localStorage.setItem("saved_table_id", selectedTableNumber);
            localStorage.setItem("saved_table_customer_id", data.customer_id);
            $(this).attr("data-table-customer-id", data.customer_id);
          }

          if (
            window.globalSocket &&
            window.globalSocket.readyState === WebSocket.OPEN
          ) {
            window.globalSocket.send(
              JSON.stringify({
                type: "update_table_customer_products",
                table_customer_id: tableCustomerId,
              }),
            );
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
    $(document).on("click", "#view-saved-table", function (e) {
      e.preventDefault();
    });
    // $(document).on("click", "", function (e) {
    //   e.preventDefault();
    // });
    // $(document).on("click", "", function (e) {
    //   e.preventDefault();
    // });

    $(document).on("click", "#order-storage-modal", function () {
      if (hasBeenInactive) {
        showClearCartConfirmation();
        return;
      }
      let products_in_cart = 0;

      if (
        locationCart.number_of_products !== undefined &&
        locationCart.number_of_products >= 0 &&
        !locationCart.table_number
      ) {
        products_in_cart = locationCart.number_of_products;
      }

      locationId = $(this).attr("data-location-id");
      if (!storageModalAjaxLock) {
        storageModalAjaxLock = true;
        $.ajax({
          type: "POST",
          url: "/ajax/order/get_order_storage_modal",
          data: {
            organizer_id: organizerId,
            location_id: locationId,
            products_in_cart: products_in_cart,
          },
        })
          .done(function (data) {
            if (data.html !== undefined && data.html !== null) {
              if ($("#order-storage-list-modal").length > 0) {
                $("#order-storage-list-modal").remove();
              }
              $("#content-body").append(data.html);
              $("#order-storage-list-modal").modal("show");
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
          })
          .always(function () {
            storageModalAjaxLock = false;
          });
      }
    });

    $(document).on("click", "#extra-table", function () {
      $("#context-menu").hide();
      $("#extraTableModal").modal("show");
      $("#extraTableName").focus();
    });

    $(document).on("click", "#delete-table", function () {
      $("#context-menu").hide();
      $("#deleteTableModal").modal("show");
    });

    $(document).on("click", "#extra-table-name-cancel", function () {
      $("#extraTableModal").modal("hide");
      $("#context-menu").css({
        display: "block",
      });
    });

    $(document).on("click", "#delete-table-cancel", function () {
      $("#deleteTableModal").modal("hide");

      $("#context-menu").css({
        display: "block",
      });
    });

    $(document).on(
      "hide.bs.modal",
      "#delete-table-cancel, #extra-table-name-cancel, #order-storage-list-modal",
      function () {
        setTimeout(() => {
          $(this).find(":focus").blur();
        }, 10);
      },
    );

    $(document).on("click", "#extra-table-name-confirm", function () {
      let extraTableName = $("#extraTableName").val();
      let oldTableName = $("#extra-table").attr("data-identifier");
      $.ajax({
        type: "POST",
        url: "/ajax/order/extra_table",
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          original_table_name: oldTableName,
          extra_table_name: extraTableName,
        },
      })
        .done(function (data) {
          if (data) {
            $("#order-table-list-modal").modal("hide");
            $("#order-storage-list-modal").modal("hide");
            $(".modal-backdrop").remove();
            popupAlert();
            $("#order-storage-modal").click();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
    $(document).on("click", "#delete-table-confirm", function () {
      let tableToDelete = $("#delete-table").attr("data-identifier");

      if (tableToDelete == locationCart.table_number) {
        alert(
          "Denne bord er i bruk for øyeblikket og har varer i handlekurven. Tøm handlekurven før du sletter bord .",
        );
        return;
      }
      $.ajax({
        type: "POST",
        url: "/ajax/order/delete_product_table",
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          table_id: tableToDelete,
        },
      })
        .done(function (data) {
          if (data.success) {
            $("#order-table-list-modal").modal("hide");
            $("#order-storage-list-modal").modal("hide");
            $(".modal-backdrop").remove();
            popupAlert();
            fetchDataAndSend();
            $("#order-storage-modal").click();
          } else {
            alert("Cannot delete this table");
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on("click", "#move-table", function () {
      let identifier = $(this).data("identifier");
      if (identifier == locationCart.table_number) {
        alert(
          "Denne bord er i bruk for øyeblikket og har varer i handlekurven. Tøm handlekurven før du flytt bord .",
        );
        return;
      }
      let products_in_cart = 0;
      if (
        locationCart.number_of_products !== undefined &&
        locationCart.number_of_products >= 0
      ) {
        products_in_cart = locationCart.number_of_products;
      }
      $.ajax({
        type: "POST",
        url: "/ajax/order/get_order_table_modal",
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          products_in_cart: products_in_cart,
          identifier,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            if ($("#order-table-list-modal").length > 0) {
              $("#order-table-list-modal").remove();
            }
            $("#order-storage-list-modal").after(data.html);
            $("#order-table-list-modal").modal("show");
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        })
        .always(function () {
          setTimeout(function () {
            orderStorageIdentifierSelectAjaxLock = false;
          }, 3000);
        });
    });

    $(document).on("click", ".order-table-move", function () {
      let fromIdentifier = $(this).data("from-identifier");
      let toIdentifier = $(this).data("identifier");

      $.ajax({
        type: "POST",
        url: "/ajax/order/move_table",
        data: {
          organizer_id: organizerId,
          location_id: locationId,
          fromIdentifier,
          toIdentifier,
        },
      })
        .done(function (data) {
          if (data) {
            $("#order-table-list-modal").modal("hide");
            $("#order-storage-list-modal").modal("hide");
            popupAlert();
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });

    $(document).on(
      "click",
      ".order-storage-list .order-storage-list-identifier",
      function () {
        if (!orderStorageIdentifierSelectAjaxLock) {
          orderStorageIdentifierSelectAjaxLock = true;

          if (
            locationCart.number_of_products == 0 ||
            locationCart.table_number
          ) {
            const identifier = $(this).attr("data-identifier");
            const extraTable = $(this).attr("data-extra-table");
            const cart_products = [];
            locationCart.products = [];
            locationCart.customer_id = "";
            $(".customer-item").removeClass("selected");
            locationCart.checkout_type = "";

            $.ajax({
              type: "POST",
              url: "/ajax/order/get_saved_order_table",
              data: {
                organizer_id: organizerId,
                location_id: locationId,
                table_id: identifier,
                extra_table_id: extraTable,
                cart_products,
              },
            })
              .done(function (data) {
                if (
                  data.location_id !== undefined &&
                  data.location_id !== null &&
                  data.location_id == locationId
                ) {
                  $("#order-storage-list-modal").modal("hide");
                  data.tableDirectAddToCart = true;
                  if (posType === "classic") {
                    setClassicLocationCart(data);
                  } else {
                    setLocationCart(data);
                  }
                }
              })
              .fail(function (data) {
                if (
                  data.responseJSON.redirect_url !== undefined &&
                  data.responseJSON.redirect_url !== null
                ) {
                  document.location.href = data.responseJSON.redirect_url;
                }
              })
              .always(function () {
                setTimeout(function () {
                  orderStorageIdentifierSelectAjaxLock = false;
                }, 300);
              });
          } else {
            const identifier = $(this).data("identifier");
            const cart_products = locationCart.products;
            const extraTable = $(this).attr("data-extra-table");
            const numbersOfProducts = locationCart.number_of_products;

            $.ajax({
              type: "POST",
              url: "/ajax/order/save_order_product",
              data: {
                organizer_id: organizerId,
                location_id: locationId,
                table_id: identifier,
                extra_table_id: extraTable,
                is_printed: window.ReactNativeWebView ? 1 : 0,
                cart_products,
                comment: locationCart.comment,
              },
            })
              .done(function (data) {
                $(".toast-container").css("z-index", 1080);
                const tableToast = $("#saved-table-toast");
                const totalAmount =
                  $("#cart-amount-with-tips").attr(
                    "data-cart-amount-with-tips",
                  ) ?? $("#original-total-amount").text();

                const tableTostMessage = `<span> Sum <strong>${totalAmount}</strong> og <strong>${locationCart.number_of_products}</strong> varer satt på <strong>${identifier}</strong></span>`;
                if (tableToast.length) {
                  $(".toast-body-message").html(tableTostMessage);
                  tableToast.toast("show");
                }
                if (
                  data.location_id !== undefined &&
                  data.location_id !== null &&
                  data.location_id == locationId
                ) {
                  $("#order-storage-list-modal").modal("hide");
                  setTimeout(() => {
                    emptyAllCart();
                  }, 1000);
                }
                fetchDataAndSend();
                if (data && data.orderData.length > 0 && window.ReactNativeWebView) {
                  const currentDeviceId = localStorage.getItem("deviceID");
                  if (data.mainPosDeviceId && data.mainPosDeviceId !== currentDeviceId) {
                    checkDeviceActive(data.mainPosDeviceId)
                      .then(function (isActive) {
                        if (isActive) {
                          let socketData = {
                            type: "main-device-print-service",
                            main_pos_device_id: data.mainPosDeviceId,
                            requested_device_id: currentDeviceId,
                            printData: {
                              action: "saved_table_print",
                              data: data.orderData
                            }
                          };

                          window.globalSocket.send(JSON.stringify(socketData));
                        } else {
                          showToast({
                            type: "error",
                            message: "Kunne ikke skrive ut. Hoved-POS-enheten kan være inaktiv."
                          })
                        }
                      })
                  } else {
                    passDataToWebView(event, "saved_table_print", data.orderData);
                  }
                }
              })
              .fail(function (data) {
                if (
                  data.responseJSON.redirect_url !== undefined &&
                  data.responseJSON.redirect_url !== null
                ) {
                  document.location.href = data.responseJSON.redirect_url;
                }
              })
              .always(function () {
                setTimeout(function () {
                  orderStorageIdentifierSelectAjaxLock = false;
                }, 300);
              });
          }
        }
      },
    );

    $(document).on(
      "click",
      "#add-to-checkout, #add-to-cart-from-table",
      function () {
        const tableId = $(this).attr("data-identifier");
        const tableButton = $(`button[data-identifier="${tableId}"]`);
        const extraTable = tableButton.attr("data-extra-table");
        locationCart.products = [];
        locationCart.customer_id = "";
        $(".customer-item").removeClass("selected");
        locationCart.checkout_type = "";

        let addToCartFromTable = 1;

        if ($("#split-payment-cart-modal").length) {
          $("#split-payment-cart-modal").modal("hide");
        }

        if (!orderStorageIdentifierSelectAjaxLock) {
          orderStorageIdentifierSelectAjaxLock = true;
          $.ajax({
            type: "POST",
            url: "/ajax/order/get_saved_order_table",
            data: {
              organizer_id: organizerId,
              location_id: locationId,
              table_id: tableId,
              extra_table_id: extraTable,
              cart_products: [],
              add_to_cart_from_table: addToCartFromTable,
            },
          })
            .done(function (data) {
              if (
                data.location_id !== undefined &&
                data.location_id !== null &&
                data.location_id == locationId
              ) {
                $("#order-storage-list-modal").modal("hide");
                if (posType === "classic") {
                  if (data.unassigned_cart_products.length > 0) {
                    data.products = data.unassigned_cart_products;
                  }
                  setClassicLocationCart(data);
                } else {
                  setLocationCart(data);
                }
              }
            })
            .fail(function (data) {
              if (
                data.responseJSON.redirect_url !== undefined &&
                data.responseJSON.redirect_url !== null
              ) {
                document.location.href = data.responseJSON.redirect_url;
              }
            })
            .always(function () {
              setTimeout(function () {
                orderStorageIdentifierSelectAjaxLock = false;
              }, 3000);
            });
        }
      },
    );

    $(document).on("click", "#close-context-menu", function () {
      if (!$("#context-menu").hasClass("d-none")) {
        $("#context-menu").addClass("d-none");
      }
      $("#order-storage-list-modal").find(".modal-content").css({
        height: "auto",
      });

      $("#order-storage-list-modal button[aria-label='Close']").css({
        opacity: 1,
        pointerEvents: "auto",
      });
    });

    $(document).on(
      "mousedown touchstart",
      ".order-storage-list .saved-identifier",
      function (e) {
        if (locationCart.number_of_products > 0) {
          return;
        }
        const identifier = $(this).data("identifier");
        const hasPaidCustomer = $(this).attr("data-has-paid-customer") === "1";
        const numberOfProductsInCart = $("#order-storage-list-modal").attr(
          "data-cart-count",
        );
        if (Number(numberOfProductsInCart) > 0) {
          isLongPress = false;
          return;
        }

        longPressTimer = setTimeout(function () {
          isLongPress = true;
          showContextMenu(identifier, hasPaidCustomer);
        }, 1000);
      },
    );

    function showContextMenu(identifier, hasPaidCustomer) {
      const contextMenu = $("#context-menu");
      const moveTableButton = $("#move-table");
      const extraTableButton = $("#extra-table");
      const deleteTableButton = $("#delete-table");
      const splitTableButton = $("#split-payment");
      const addToCheckoutButton = $("#add-to-checkout");
      const contextMenuHeader = $(".context-menu-header h5");

      $("#order-storage-list-modal button[aria-label='Close']").css({
        opacity: 0,
        pointerEvents: "none",
      });

      contextMenu.attr("data-identifier", identifier);
      extraTableButton.attr("data-identifier", identifier);
      deleteTableButton.attr("data-identifier", identifier);
      moveTableButton.attr("data-identifier", identifier);
      splitTableButton.attr("data-identifier", identifier);
      addToCheckoutButton.attr("data-identifier", identifier);
      contextMenuHeader.text(identifier);

      if (hasPaidCustomer) {
        deleteTableButton.addClass("disabled");
        moveTableButton.addClass("disabled");
        addToCheckoutButton.addClass("disabled");
      } else {
        deleteTableButton.removeClass("disabled");
        moveTableButton.removeClass("disabled");
        addToCheckoutButton.removeClass("disabled");
      }

      $("#order-storage-list-modal").find(".modal-content").css({
        height: "450px",
      });
      $("#context-menu").removeClass("d-none");
    }

    $(document).on(
      "mouseup touchend",
      ".order-storage-list .saved-identifier",
      function () {
        clearTimeout(longPressTimer);
      },
    );

    $(document).on(
      "mouseleave touchend",
      ".order-storage-list .saved-identifier",
      function () {
        clearTimeout(longPressTimer);
        isLongPress = false;
      },
    );

    $(document).on("click touchstart", "#context-menu", function (e) {
      e.stopPropagation();
    });

    $(document).on("submit", "#order-storage-identifier-form", function (e) {
      e.preventDefault();
      const identifier = $(
        "#order-storage-identifier-form #order-storage-identifier-new",
      ).val();
      const extraTable = $(this).attr("data-extra-table") ?? "";

      if (!orderStorageIdentifierFormSubmitAjaxLock && identifier != "") {
        orderStorageIdentifierFormSubmitAjaxLock = true;

        locationCart.order_storage_identifier = identifier;
        const cart_products = locationCart.products;

        $.ajax({
          type: "POST",
          url: "/ajax/order/save_order_product",
          data: {
            organizer_id: organizerId,
            location_id: locationId,
            table_id: identifier,
            extra_table_id: extraTable,
            temporary_table: 1,
            cart_products,
            comment: locationCart.comment,
          },
        })
          .done(function (data) {
            $(".toast-container").css("z-index", 1080);
            const tableToast = $("#saved-table-toast");
            const totalAmount =
              $("#cart-amount-with-tips").attr("data-cart-amount-with-tips") ??
              $("#original-total-amount").text();

            const tableTostMessage = `<span> Sum <strong>${totalAmount}</strong> og <strong>${locationCart.number_of_products}</strong> varer satt på <strong>${identifier}</strong></span>`;
            if (tableToast.length) {
              $(".toast-body-message").html(tableTostMessage);
              tableToast.toast("show");
            }

            fetchDataAndSend();

            if (
              data.location_id !== undefined &&
              data.location_id !== null &&
              data.location_id == locationId
            ) {
              $("#order-storage-list-modal").modal("hide");
              emptyAllCart();
              popupAlert();

              orderStorageIdentifierSelectAjaxLock = false;
              orderStorageIdentifierFormSubmitAjaxLock = false;
            }
          })
          .fail(function (data) {
            if (
              data.responseJSON.redirect_url !== undefined &&
              data.responseJSON.redirect_url !== null
            ) {
              document.location.href = data.responseJSON.redirect_url;
            }
            if (
              data.responseJSON.error_message !== undefined &&
              data.responseJSON.error_message !== null
            ) {
              $("#message").remove();
              prependAlertUnClose(
                ".order-storage-list-container",
                data.responseJSON.error_message,
                "danger",
                null,
              );
              $("#order-storage-identifier-new").focus();
            }
          })
          .always(function () {
            orderStorageIdentifierFormSubmitAjaxLock = false;
          });
      }
      return false;
    });

    $(document).on("click", "#print-advance-receipt", function () {
      const identifier = $("#context-menu").attr("data-identifier");

      $.ajax({
        type: "POST",
        url: "/api/v1/private/printer/advance-receipt",
        data: {
          identifier,
          organizer_id: organizerId,
          location_id: locationId,
        },
      })
        .done(function (data) {
          if (data && data.print_data) {
            passDataToWebView(
              event,
              "advance_receipt",
              data.print_data.orderProducts,
              data.print_data.ipAddress,
              data.print_data.printerType,
              data.print_data.organizer,
            );
          }

          $("#context-menu").hide();
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }
});
